"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Payment = class Payment extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_autocalcAmount = new core_1.ComponentValueCache(this, "autocalcAmount", "PaymentInvoices.autocalcAmount");
    }
    recalculateAmountFromLines(...args) {
        const item = this.item;
        if (item.isReadonly) {
            return;
        }
        const [invoiceData] = args;
        if (invoiceData) {
            const idx = _.findIndex(item.invoices.data, { invoice_id: invoiceData.invoice_id });
            if (idx > -1) {
                _.extend(item.invoices.data[idx], invoiceData);
            }
        }
        if (!this.autocalcAmount) {
            return;
        }
        const summa = this.$fn.numeral(0);
        if (!item.invoices || !item.invoices.data) {
            return;
        }
        for (let d of item.invoices.data) {
            summa.add(d.amount);
        }
        item.amount = summa.value();
        if (this.isPettyCashPayment) {
            item.amount = Math.abs(item.amount);
        }
    }
    reloadTemplate(...args) {
        this.loadData('item');
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    invoices;
    onInvoices(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoices");
    }
    accountId;
    onAccount_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("accountId");
    }
    transactionKind;
    onTransaction_kind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("transactionKind");
    }
    transactionType;
    onTransaction_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("transactionType");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    messages;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    autocalcAmount;
    item;
    async $$load_item() {
        return this.oid == null
            ? this.$fn.fetch('get_payment_template', {
                asResource: true,
                parameters: {
                    kind: this.transactionKind,
                    type: this.transactionType,
                    invoices: this.invoices ? this.invoices.join(',') : null,
                    account_id: (this.$data.item && this.$data.item.account && this.$data.item.account.id) || this.accountId
                }
            })
            : this.$fn.fetch('read_payment', { asResource: true, parameters: { id: this.oid } });
    }
    allConfig;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['messages', 'formId', 'autocalcAmount', 'item', 'allConfig', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    saveChanges: this.$fn.pgettext("Button", "Save changes"),
                    createPayment: this.$fn.pgettext("Button", "Create payment"),
                },
                formId: null,
                autocalcAmount: true,
                item: null,
                allConfig: {
                    transactionTypes: {
                        bank: {
                            credit: this.$fn.pgettext("TransactionType", "credit"),
                            debit: this.$fn.pgettext("TransactionType", "debit"),
                        },
                        cash_book: {
                            deposit: this.$fn.pgettext("TransactionType", "deposit"),
                            payment: this.$fn.pgettext("TransactionType", "payment"),
                        },
                        technical: {
                            invoice_reconciliation: this.$fn.pgettext("TransactionType", "invoice reconciliation"),
                            write_off: this.$fn.pgettext("TransactionType", "write off"),
                        },
                    },
                    bank: {
                        credit: {
                            fields: {},
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Bank credit"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                        debit: {
                            fields: {},
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Bank debit"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                    },
                    cash_book: {
                        deposit: {
                            fields: {
                                transaction_number: false,
                                transaction_type: "ro",
                                exchange_rate: false,
                                statement_number: false,
                                transaction_code: false,
                            },
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Cash-In"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                        payment: {
                            fields: {
                                transaction_number: false,
                                transaction_type: "ro",
                                exchange_rate: false,
                            },
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Cash-Out"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                    },
                    technical: {
                        invoice_reconciliation: {
                            fields: {
                                amount: false,
                                exchange_rate: false,
                                transaction_number: false,
                                payment_method: false,
                                employee: false,
                                statement_number: false,
                                transaction_code: false,
                            },
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Invoice reconciliation"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                        write_off: {
                            fields: {
                                amount: false,
                                exchange_rate: false,
                                transaction_number: false,
                                payment_method: false,
                                employee: false,
                                statement_number: false,
                                transaction_code: false,
                            },
                            resourceTitle: this.$fn.pgettext("Payment|Header", "Write off"),
                            newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
                        },
                    },
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get isDeletable() {
        if (this.loaded) {
            return this.oid != null;
        }
        return null;
    }
    get isNew() {
        if (this.loaded) {
            return this.item && this.item.id == null;
        }
        return null;
    }
    get isPettyCashPayment() {
        if (this.loaded) {
            return this.item.account && this.item.account.account_type === 'cash_book';
        }
        return null;
    }
    get config() {
        if (this.loaded) {
            return this.allConfig[this.item.transaction_kind][this.item.transaction_type];
        }
        return null;
    }
    get transactionTypes() {
        if (this.loaded) {
            return this.allConfig.transactionTypes[this.item.transaction_kind];
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3880_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_3888_getActionArgs($event) {
        return {
            grid: "payments",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_3892_getActionArgs($event) {
        return {
            path: "item",
            value: $event && $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_setData_3892_getWhen($event) {
        return !!$event.data;
    }
    async act_1040167445267876_reloadSlickgrid_3894_getActionArgs($event) {
        return {
            grid: "payments",
        };
    }
    async act_1040167445267876_reloadSlickgrid_3894_getWhen($event) {
        return !!$event.data;
    }
    async act_1040167445267876_crud_3890_getActionArgs($event) {
        return {
            objectType: "payment",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_script_3896_getActionArgs_value($event) {
        this.reloadTemplate($event.data);
    }
    async act_5534025912102772_script_3896_getActionArgs($event) {
        return {
            value: () => this.act_5534025912102772_script_3896_getActionArgs_value($event),
        };
    }
    async evh_5534025912102772_accountChanged(event, scope) {
        return await this.actions.evh_5534025912102772_accountChanged.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_setData_3898_getActionArgs($event) {
        return {
            path: "autocalcAmount",
            value: $event.originalEvent,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5534025912102772_autocalcAmountChanged(event, scope) {
        return await this.actions.evh_5534025912102772_autocalcAmountChanged.executeFromDOM(this, event, scope);
    }
    async act_3083451129821185_script_3900_getActionArgs_value($event) {
        this.recalculateAmountFromLines($event.data);
    }
    async act_3083451129821185_script_3900_getActionArgs($event) {
        return {
            value: () => this.act_3083451129821185_script_3900_getActionArgs_value($event),
        };
    }
    async evh_3083451129821185_recalculate(event, scope) {
        return await this.actions.evh_3083451129821185_recalculate.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_setData_3902_getActionArgs($event) {
        return {
            path: "item",
            value: this.item.clone({
                id: null,
                rev: null,
                transaction_number: this.isPettyCashPayment ? null : this.item.transaction_number,
                amount: 0,
                links: null,
                etag: null,
                invoices: { data: [] },
                preview_url: null,
                locked: false,
                notes: null,
                internal_notes: null,
            }),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3880 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3880_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3879 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3880,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3879],
        });
        const act_2248226175642056_closeModal_3882 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3881 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3882,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3881],
        });
        const act_8564662037462133_reloadComponentData_3884 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_3883 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_3884,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_3883],
        });
        const act_8564662037462133_closeModal_3886 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_8564662037462133_deleted_3885 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeModal_3886,
            event: "deleted",
            displayName: "closeModal",
        });
        const act_8564662037462133_reloadSlickgrid_3888 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_3888_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_3887 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_3888,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_3885, evh_8564662037462133_deleted_3887],
        });
        const act_1040167445267876_setData_3892 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_3892_getActionArgs,
            when: this.act_1040167445267876_setData_3892_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_3891 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_3892,
            event: "success",
            displayName: "setData",
        });
        const act_1040167445267876_reloadSlickgrid_3894 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_3894_getActionArgs,
            when: this.act_1040167445267876_reloadSlickgrid_3894_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_3893 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_3894,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_crud_3890 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_3890_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3891, evh_1040167445267876_success_3893],
        });
        const evh_1040167445267876_submit_3889 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_3890,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3889],
        });
        const act_5534025912102772_script_3896 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5534025912102772_script_3896_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_accountChanged_3895 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_script_3896,
            event: "accountChanged",
            displayName: "script",
        });
        const evh_5534025912102772_accountChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_accountChanged_3895],
        });
        const act_5534025912102772_setData_3898 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5534025912102772_setData_3898_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_autocalcAmountChanged_3897 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_setData_3898,
            event: "autocalcAmountChanged",
            displayName: "setData",
        });
        const evh_5534025912102772_autocalcAmountChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_autocalcAmountChanged_3897],
        });
        const act_3083451129821185_script_3900 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3083451129821185_script_3900_getActionArgs,
            events: [],
        });
        const evh_3083451129821185_recalculate_3899 = new core_1.actions.EventHandlerImpl({
            action: act_3083451129821185_script_3900,
            event: "recalculate",
            displayName: "script",
        });
        const evh_3083451129821185_recalculate = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3083451129821185_recalculate_3899],
        });
        const act_1548630417156826_setData_3902 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1548630417156826_setData_3902_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_3901 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_setData_3902,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_3901],
        });
        return {
            act_7315092382398562_closeModal_3880,
            evh_7315092382398562_close_3879,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3882,
            evh_2248226175642056_close_3881,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_3884,
            evh_8564662037462133_reload_3883,
            evh_8564662037462133_reload,
            act_8564662037462133_closeModal_3886,
            evh_8564662037462133_deleted_3885,
            act_8564662037462133_reloadSlickgrid_3888,
            evh_8564662037462133_deleted_3887,
            evh_8564662037462133_deleted,
            act_1040167445267876_setData_3892,
            evh_1040167445267876_success_3891,
            act_1040167445267876_reloadSlickgrid_3894,
            evh_1040167445267876_success_3893,
            act_1040167445267876_crud_3890,
            evh_1040167445267876_submit_3889,
            evh_1040167445267876_submit,
            act_5534025912102772_script_3896,
            evh_5534025912102772_accountChanged_3895,
            evh_5534025912102772_accountChanged,
            act_5534025912102772_setData_3898,
            evh_5534025912102772_autocalcAmountChanged_3897,
            evh_5534025912102772_autocalcAmountChanged,
            act_3083451129821185_script_3900,
            evh_3083451129821185_recalculate_3899,
            evh_3083451129821185_recalculate,
            act_1548630417156826_setData_3902,
            evh_1548630417156826_clickPreventStop_3901,
            evh_1548630417156826_clickPreventStop,
            save: act_1040167445267876_crud_3890,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Payment.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
        default: null,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], Payment.prototype, "invoices", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoices'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onInvoices", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Payment.prototype, "accountId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('accountId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onAccount_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Payment.prototype, "transactionKind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('transactionKind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onTransaction_kind", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Payment.prototype, "transactionType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('transactionType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onTransaction_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Payment.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "onSize", null);
Payment = __decorate([
    (0, vue_property_decorator_1.Component)()
], Payment);
exports.default = Payment;
vue_property_decorator_1.Vue.component("Payment", Payment);
